'use client';

interface Option {
  id: string;
  name: string;
  price: number;
  required: boolean;
  disabled?: boolean;
}

interface OptionSectionProps {
  title: string;
  required: boolean;
  options: Option[];
  selectedOption?: string;
  onOptionChange: (optionId: string) => void;
}

export default function OptionSection({
  title,
  required,
  options,
  selectedOption,
  onOptionChange,
}: OptionSectionProps) {
  return (
    <section className="px-5 py-5">
      {/* 섹션 제목 */}
      <div className="flex items-center gap-0.5 mb-5">
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        {required && <span className="text-base font-semibold text-red-500">*</span>}
      </div>

      {/* 옵션 리스트 */}
      <div className="flex flex-col gap-5">
        {options.map(option => (
          <button
            key={option.id}
            type="button"
            disabled={option.disabled}
            className={`flex items-center gap-2.5 text-left ${
              option.disabled ? 'opacity-40 cursor-not-allowed' : ''
            }`}
            onClick={() => onOptionChange(option.id)}
          >
            {/* 라디오 버튼 */}
            <div
              className={`w-[22px] h-[22px] rounded-full border flex items-center justify-center ${
                selectedOption === option.id ? 'border-blue-500 bg-blue-500' : 'border-gray-300 bg-white'
              }`}
            >
              {selectedOption === option.id && <div className="w-3 h-3 rounded-full bg-white" />}
            </div>

            {/* 옵션 이름 */}
            <span className="text-base font-medium text-gray-900 leading-[1.625]">{option.name}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
